// extracted by mini-css-extract-plugin
export default {"page-content":"Page_page-content__jf+ZR","frame-wrapper":"Page_frame-wrapper__RHbdf","sidebar-wrapper":"Page_sidebar-wrapper__N026H"};